import { useState, useEffect } from "react";
import { CardMedia, Skeleton } from "@mui/material";
import { onDragStart } from "utilities/dragndrop";
import { Media } from "types/qbank/media";
import { useApi } from "hooks/api";
import { useSessionDetails } from "hooks/sessionDetails";
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";

const HEIGHT = 160;

type IProps = {
  media: Media;
  thumbnailSrc: string;
  publishSrc: string;
  alt: string;
};

const CardImage = (props: IProps) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);
  const { logUsage } = useApi();
  const { sessionId, sessionDetails, setSessionDetailsModal } =
    useSessionDetails();
  const { mutate: logUsageMutation } = useMutation("logUsage", logUsage);
  const { enqueueSnackbar } = useSnackbar();
  const { media } = props;
  const [os, setOs] = useState<string | null>(null);
  const [isPop, setIsPop] = useState(true);

  useEffect(() => {
    const detectOS = () => {
      const platform = window.navigator.platform.toLowerCase();
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (platform.includes('win')) {
        setOs('Windows');
      } else if (platform.includes('mac') || userAgent.includes('macintosh')) {
        setOs('Mac');
      } else {
        setOs('Unknown OS');
      }
    };
    detectOS();
    const queryParams = new URLSearchParams(window.location.search);
    setIsPop(queryParams.get('popup') === 'true');
  }, []);
  const updateUsage = (showmsg: boolean) => {
    if (
      sessionDetails.username === undefined ||
      sessionDetails.email === undefined
    ) {
      setSessionDetailsModal({ open: true, media });
    } else {
      logUsageMutation({
        sessionId,
        media,
        sessionDetails,
      });
    }
    if (showmsg) {
      enqueueSnackbar("Drag and drop completed successfully.", {
        variant: "success",
      })
    }
  };

  return (
    <>
      {!loaded && <Skeleton variant="rectangular" height={HEIGHT} />}
      <div style={{ backgroundColor: "#eee" }}>
        <CardMedia
          style={{ width: "initial", maxWidth: "100%", objectFit: "contain", marginLeft: "auto", marginRight: "auto" }}
          classes={{ img: 'is-checkered-background' }}
          component="img"
          height={loaded ? HEIGHT : 0}
          image={props.thumbnailSrc}
          alt={failed ? "Failed to load image" : props.alt}
          onLoad={() => {
            setLoaded(true);
          }}
          // @ts-ignore
          onError={(e) => {
            setFailed(true);
            setLoaded(true);
          }}
          draggable={!failed && loaded}
          onDragStart={(e: {
            dataTransfer: { dropEffect: string; effectAllowed: string };
          }) => onDragStart(props.publishSrc, props.alt, e)}
          onDragLeave={(e: any) => {
            if (os !== "Windows" && !isPop) {
              updateUsage(false)
            }
          }
          }
          onDragEnd={(e: any) => {
            if (os === "Windows" || isPop) {
              updateUsage(true)
            }
          }
          }
        />
      </div>
    </>
  );
};

export default CardImage;
